import { render, staticRenderFns } from "./Markings.vue?vue&type=template&id=d4f8c9e2&scoped=true"
import script from "./Markings.vue?vue&type=script&lang=js"
export * from "./Markings.vue?vue&type=script&lang=js"
import style0 from "./Markings.vue?vue&type=style&index=0&id=d4f8c9e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f8c9e2",
  null
  
)

export default component.exports